import React from "react";
import "./evidence-card.scss";

export interface EvidenceCardProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title" | "children"> {
  cardBackGroundColor?: string;
  title?: string;
  statements?: string[];
  /** Optional element rendered at the extreme right of the title row (e.g. badge, icon button, link). */
  titleAction?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const EvidenceCard = ({
  cardBackGroundColor = "#e9fff4",
  title = "Supportive Statement",
  statements,
  titleAction,
  children,
  className,
  style,
  ...rest
}: EvidenceCardProps) => {
  const titleId = rest.id ? `${rest.id}-title` : undefined;

  return (
    <article
      className={["evidence-card", className].filter(Boolean).join(" ")}
      style={{ backgroundColor: cardBackGroundColor, ...style }}
      aria-labelledby={titleId}
      {...rest}
    >
      <div className="evidence-card__body">
        <div className="evidence-card__header">
          <p id={titleId} className="evidence-card__title">
            {title}
          </p>
          {titleAction != null && (
            <div className="evidence-card__title-action">{titleAction}</div>
          )}
        </div>

        {statements != null && statements.length > 0 && (
          <ul className="evidence-card__list">
            {statements.map((statement, index) => (
              <li key={statement + index} className="evidence-card__list-item">
                {statement}
              </li>
            ))}
          </ul>
        )}

        {children}
      </div>
    </article>
  );
};

export { EvidenceCard };
export default EvidenceCard;
